export function LogoDark({
  ...props
}: React.SVGAttributes<SVGElement>): JSX.Element {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 117 36' {...props}>
      <g clipPath='url(#a)'>
        <path
          fill='#4568A5'
          fillRule='evenodd'
          d='m30.208 28.318.025-.015a2.54 2.54 0 0 0 1.138-1.5c.174-.628.1-1.3-.205-1.875l-2.905-5.536L6.38 30.98l7.827 4.539a3.573 3.573 0 0 0 3.584 0l12.416-7.2Z'
          clipRule='evenodd'
        />
        <mask
          id='b'
          width={26}
          height={17}
          x={6}
          y={19}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'alpha',
          }}
        >
          <path
            fill='#4568A5'
            fillRule='evenodd'
            d='m30.208 28.318.025-.015a2.54 2.54 0 0 0 1.138-1.5c.174-.628.1-1.3-.205-1.875l-2.905-5.536L6.38 30.98l7.827 4.539a3.573 3.573 0 0 0 3.584 0l12.416-7.2Z'
            clipRule='evenodd'
          />
        </mask>
        <g
          filter='url(#c)'
          mask='url(#b)'
          opacity={0.3}
          style={{
            mixBlendMode: 'darken',
          }}
        >
          <ellipse
            cx={34.584}
            cy={25.526}
            fill='#000'
            rx={8.725}
            ry={14}
            transform='rotate(-11.677 34.584 25.526)'
          />
        </g>
        <path
          fill='#4568A5'
          fillRule='evenodd'
          d='M3.94 22.346 21.494 2.628 17.792.482a3.573 3.573 0 0 0-3.584 0l-12.416 7.2A3.612 3.612 0 0 0 0 10.8v2.7c0 1.67.35 3.32 1.03 4.845a11.862 11.862 0 0 0 2.91 4v.002Z'
          clipRule='evenodd'
        />
        <mask
          id='d'
          width={22}
          height={24}
          x={0}
          y={-1}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'alpha',
          }}
        >
          <path
            fill='#4568A5'
            fillRule='evenodd'
            d='M3.94 22.346 21.494 2.628 17.792.482a3.573 3.573 0 0 0-3.584 0l-12.416 7.2A3.612 3.612 0 0 0 0 10.8v2.7c0 1.67.351 3.32 1.03 4.845a11.862 11.862 0 0 0 2.91 4v.002Z'
            clipRule='evenodd'
          />
        </mask>
        <g
          filter='url(#e)'
          mask='url(#d)'
          opacity={0.3}
          style={{
            mixBlendMode: 'darken',
          }}
        >
          <ellipse
            cx={1.002}
            cy={16.63}
            fill='#000'
            rx={7}
            ry={14}
            transform='rotate(-23.5 1.002 16.63)'
          />
        </g>
        <path
          fill='#608BD8'
          fillRule='evenodd'
          d='m30.208 7.682-.419-.243-10.016 9.25 8.4 7.313c1.325 1.152 1.816 2.833 1.304 4.743l.731-.424a3.592 3.592 0 0 0 1.313-1.32c.315-.548.48-1.17.48-1.802v-14.4a3.612 3.612 0 0 0-1.793-3.117ZM15.57 20.637 3.996 11.67c-1.304-1.016-1.893-2.536-1.625-4.322l-.579.335A3.612 3.612 0 0 0 0 10.8v14.4c0 .633.164 1.255.479 1.803a3.591 3.591 0 0 0 1.313 1.32l3.315 1.922 10.463-9.608Z'
          clipRule='evenodd'
        />
        <mask
          id='f'
          width={16}
          height={24}
          x={0}
          y={7}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'alpha',
          }}
        >
          <path
            fill='#608BD8'
            fillRule='evenodd'
            d='M15.57 20.637 3.996 11.67c-1.304-1.016-1.893-2.536-1.625-4.322l-.579.335A3.612 3.612 0 0 0 0 10.8v14.4c0 .633.164 1.255.479 1.803a3.591 3.591 0 0 0 1.313 1.32l3.315 1.922 10.463-9.608Z'
            clipRule='evenodd'
          />
        </mask>
        <g
          filter='url(#g)'
          mask='url(#f)'
          opacity={0.3}
          style={{
            mixBlendMode: 'lighten',
          }}
        >
          <ellipse
            cx={-3}
            cy={14}
            fill='#fff'
            rx={7}
            ry={14}
            transform='rotate(11.873 -3 14)'
          />
        </g>
        <mask
          id='h'
          width={14}
          height={22}
          x={19}
          y={7}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'alpha',
          }}
        >
          <path
            fill='#608BD8'
            fillRule='evenodd'
            d='m30.208 7.682-.419-.243-10.016 9.25 8.4 7.313c1.325 1.152 1.816 2.833 1.304 4.743l.731-.424a3.593 3.593 0 0 0 1.313-1.32c.315-.547.48-1.17.48-1.802V10.8c0-.632-.166-1.253-.48-1.8a3.593 3.593 0 0 0-1.313-1.318Z'
            clipRule='evenodd'
          />
        </mask>
        <g
          filter='url(#i)'
          mask='url(#h)'
          opacity={0.3}
          style={{
            mixBlendMode: 'lighten',
          }}
        >
          <ellipse
            cx={36.177}
            cy={21.277}
            fill='#fff'
            rx={7}
            ry={14}
            transform='rotate(-166.007 36.177 21.277)'
          />
        </g>
        <path
          fill='#394962'
          d='M48.424 21.264c-3.41 0-5.5-2.112-5.632-4.994h2.552c.154 1.584 1.21 2.684 3.102 2.684 1.848 0 2.75-.902 2.75-2.024 0-3.41-8.052-1.804-8.052-7.282 0-2.442 1.892-4.312 5.104-4.312 3.146 0 5.148 2.134 5.28 4.862h-2.552c-.088-1.496-1.1-2.552-2.728-2.552-1.65 0-2.552.88-2.552 2.046 0 3.344 8.052 1.628 8.052 7.172 0 2.508-1.892 4.4-5.324 4.4Zm11.67 0c-2.025 0-3.498-1.43-3.498-3.872v-5.346H54.77V10h.791c.88 0 1.343-.462 1.343-1.32V7.008h2.09v2.86h2.42v2.178h-2.42v5.148c0 1.232.66 1.804 1.65 1.804.285 0 .55-.044.77-.154v2.2c-.287.11-.727.22-1.32.22Zm13.437-6.072c0 .528-.066.946-.132 1.188h-8.25c.308 1.694 1.496 2.706 3.08 2.706 1.254 0 2.002-.594 2.398-1.166h2.508c-.616 1.606-2.442 3.344-4.884 3.344-3.08 0-5.522-2.53-5.522-5.83 0-3.256 2.508-5.83 5.5-5.83 2.97 0 5.302 2.42 5.302 5.588Zm-5.302-3.41c-1.518 0-2.772 1.078-3.08 2.772h6.028c-.264-1.65-1.452-2.772-2.948-2.772ZM78.207 21h-2.42V5.6h2.42V21Zm5.436 0h-2.42V5.6h2.42V21ZM90.73 9.604c2.728 0 4.444 1.826 4.444 4.532V21h-1.804l-.44-1.254h-.11c-.44.572-1.474 1.518-3.256 1.518-2.178 0-3.74-1.496-3.74-3.322 0-2.222 2.112-3.63 5.17-3.63h1.782v-.374c0-1.342-.814-2.156-2.068-2.156-1.21 0-1.826.748-1.958 1.474h-2.42c.198-1.87 1.716-3.652 4.4-3.652Zm-.66 9.614c1.65 0 2.706-1.144 2.706-2.464v-.704h-1.76c-1.892 0-2.772.682-2.772 1.694 0 .858.616 1.474 1.826 1.474Zm11.833 2.046c-2.024 0-3.498-1.43-3.498-3.872v-5.346h-1.826V10h.792c.88 0 1.342-.462 1.342-1.32V7.008h2.09v2.86h2.42v2.178h-2.42v5.148c0 1.232.66 1.804 1.65 1.804.286 0 .55-.044.77-.154v2.2c-.286.11-.726.22-1.32.22Zm13.438-6.072c0 .528-.066.946-.132 1.188h-8.25c.308 1.694 1.496 2.706 3.08 2.706 1.254 0 2.002-.594 2.398-1.166h2.508c-.616 1.606-2.442 3.344-4.884 3.344-3.08 0-5.522-2.53-5.522-5.83 0-3.256 2.508-5.83 5.5-5.83 2.97 0 5.302 2.42 5.302 5.588Zm-5.302-3.41c-1.518 0-2.772 1.078-3.08 2.772h6.028c-.264-1.65-1.452-2.772-2.948-2.772ZM46.07 32.1c-.83 0-1.45-.57-1.6-.78h-.05l-.17.68h-.48v-7h.65v2.68h.05c.15-.22.77-.78 1.6-.78 1.26 0 2.3 1.06 2.3 2.6s-1.04 2.6-2.3 2.6Zm0-.61c.9 0 1.65-.8 1.65-1.99s-.75-1.99-1.65-1.99c-.9 0-1.65.8-1.65 1.99s.75 1.99 1.65 1.99Zm4.994-.43 1.59-4.06h.68l-2.21 5.5c-.45 1.11-.86 1.35-1.35 1.35-.16 0-.28-.04-.39-.08v-.59c.11.04.21.06.31.06.3 0 .55-.16.76-.67l.27-.68-1.99-4.89h.7l1.63 4.06Zm7.359.94h-.7v-6.35h-2.16V25h5.02v.65h-2.16V32Zm3.653 0h-.65v-7h.65v2.68h.05c.22-.34.73-.78 1.47-.78 1.13 0 1.99.86 1.99 2.2V32h-.65v-2.9c0-1-.59-1.59-1.4-1.59-.86 0-1.46.59-1.46 1.59V32Zm9.156-2.65c0 .19-.01.35-.04.47h-3.88c.11 1.03.78 1.67 1.7 1.67.63 0 1.08-.27 1.39-.79h.65c-.3.79-1.09 1.4-2.06 1.4-1.32 0-2.35-1.05-2.35-2.6 0-1.52 1.06-2.6 2.35-2.6s2.24 1.07 2.24 2.45Zm-2.24-1.84c-.84 0-1.58.69-1.69 1.72h3.27c-.06-1-.71-1.72-1.58-1.72Zm8.533 1.7v-.63h2.8V32h-.49l-.16-1.13c-.43.63-1.26 1.23-2.38 1.23-1.72 0-3.24-1.52-3.24-3.6s1.52-3.6 3.24-3.6c1.42 0 2.62.99 2.92 2.24h-.7c-.32-.87-1.07-1.59-2.22-1.59-1.34 0-2.54 1.19-2.54 2.95 0 1.76 1.2 2.95 2.54 2.95 1.27 0 2.27-.92 2.33-2.24h-2.1Zm6.084 2.89c-1.13 0-1.99-.86-1.99-2.2V27h.65v2.9c0 1 .59 1.59 1.4 1.59.86 0 1.46-.59 1.46-1.59V27h.65v5h-.48l-.17-.68h-.05c-.22.34-.73.78-1.47.78Zm3.937-5.9c-.25 0-.45-.19-.45-.45 0-.27.2-.45.45-.45.26 0 .45.18.45.45 0 .26-.19.45-.45.45Zm.32 5.8h-.65v-5h.65v5Zm2.14 0h-.65v-7h.65v7Zm3.457.1c-1.26 0-2.3-1.06-2.3-2.6s1.04-2.6 2.3-2.6c.83 0 1.45.56 1.6.78h.05V25h.65v7h-.48l-.17-.68h-.05c-.15.21-.77.78-1.6.78Zm0-.61c.9 0 1.65-.8 1.65-1.99s-.75-1.99-1.65-1.99c-.9 0-1.65.8-1.65 1.99s.75 1.99 1.65 1.99Z'
        />
      </g>
      <defs>
        <filter
          id='c'
          width={42.009}
          height={51.65}
          x={13.579}
          y={-0.299}
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur
            result='effect1_foregroundBlur_1_60'
            stdDeviation={6}
          />
        </filter>
        <filter
          id='e'
          width={41.015}
          height={50.283}
          x={-19.505}
          y={-8.511}
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur
            result='effect1_foregroundBlur_1_60'
            stdDeviation={6}
          />
        </filter>
        <filter
          id='g'
          width={38.866}
          height={51.554}
          x={-22.433}
          y={-11.777}
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur
            result='effect1_foregroundBlur_1_60'
            stdDeviation={6}
          />
        </filter>
        <filter
          id='i'
          width={39.182}
          height={51.382}
          x={16.587}
          y={-4.414}
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur
            result='effect1_foregroundBlur_1_60'
            stdDeviation={6}
          />
        </filter>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h117v36H0z' />
        </clipPath>
      </defs>
    </svg>
  )
}
